// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"882f9b00","291":"ddda1343","384":"8550f28e","445":"81b48cf2","491":"b9e3cd0a","578":"2a185831","643":"b564e704"}[chunkId] + ".chunk.js";
};